import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

import style from './style.module.scss'
import { Text } from '@crossfit/design-system'
import { ReactComponent as UploadIcon } from './upload.svg'

const MAX_SIZE = import.meta.env.VITE_MAX_IMAGE_SIZE || 5000000 //5MB

type Props = {
  onFile: (file: File) => void
}

function ImageUpload(props: Props) {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    const currentFile = acceptedFiles[0]
    if (!currentFile) {
      return
    }

    props.onFile(currentFile)
  }, [])

  const { getRootProps, getInputProps, isDragActive, fileRejections } =
    useDropzone({
      onDrop,
      maxFiles: 1,
      noClick: false,
      maxSize: MAX_SIZE,
      accept: {
        'image/jpg': [],
        'image/jpeg': [],
        'image/png': [],
      },
      multiple: false,
      onDragEnter: undefined,
      onDragOver: undefined,
      onDragLeave: undefined,
    })

  const fileRejectionErrorCode = fileRejections[0]?.errors[0]?.code
  const fileRejectionErrorMessage = fileRejections[0]?.errors[0]?.message

  return (
    <div
      {...getRootProps({ onClick: (evt) => evt.preventDefault() })}
      className={style.wrapper}
      data-isdragging={isDragActive}
    >
      <div className={style.icon}>
        <UploadIcon />
      </div>
      <input {...getInputProps()} id='fileUpload' name='fileUpload' />
      <div className={style.upload}>
        <div className={style.uploadTextWrapper}>
          <span className={style.dropText}>
            Drop your image here, or{' '}
            <span className={style.uploadText}>upload</span>
          </span>
        </div>
        <Text type='body' size='sm' className={style.description}>
          {`Files must be a JPEG or PNG and no larger than 5 MB`}
        </Text>
        {fileRejectionErrorCode === 'file-too-large' ? (
          <p
            className={style.error}
          >{`This file exceeds the maximum file size`}</p>
        ) : (
          <p className={style.error}>{fileRejectionErrorMessage}</p>
        )}
      </div>
    </div>
  )
}

export default ImageUpload
